import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { MessageText, ToastService } from 'app/helpers/services/toastService';

@Component({
  selector: 'app-tenant-sp-description',
  templateUrl: './tenant-sp-description.component.html',
  styleUrl: './tenant-sp-description.component.scss',
  standalone: false,
})
export class TenantSpDescriptionComponent implements OnInit {
  tenantId = '';
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.tenantId = this.route.snapshot.paramMap.get('id')!;
    if (!this.tenantId) {
      return;
    }
    this.http
      .get(`/api/tenants/spdescriptions/${this.tenantId}`)
      .subscribe((x: any) => {
        if (x) {
          this.selectedCategories.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesDepartment.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
          this.selectedCategoriesOperational.forEach((element) => {
            const t = x.find((f: any) => f.key == element.key);
            if (t) {
              element.description = t.description;
            }
          });
        }
      });
  }

  selectedCategories = [
    { key: '1.1', name: 'spDescValueProposition', description: '' },
    { key: '1.1.1', name: 'spDescSegmentationCriteria', description: '' },
    { key: '1.1.2', name: 'spDescDreamCustomers', description: '' },
    { key: '1.1.3', name: 'spDescSalesPhilosophy', description: '' },

    { key: '1.2', name: 'spDescKpiModel', description: '' },
    { key: '1.2.1', name: 'spDescBuyingJourneyPositioning', description: '' },
  ];

  selectedCategoriesDepartment = [
    { key: '2.1', name: 'spDescCustomerJourney', description: '' },
    { key: '2.2', name: 'spDescSalesProcess', description: '' },

    { key: '2.3', name: 'spDescPipelineManagement', description: '' },
    { key: '2.3.1', name: 'spDescHandoverAfterSales', description: '' },
    { key: '2.3.2', name: 'spDescAccountPlans', description: '' },
    { key: '2.3.3', name: 'spDescPersonasStakeholder', description: '' },
  ];

  selectedCategoriesOperational = [
    { key: '3.1', name: 'spDescCustomerMeetingsStructure', description: '' },
    { key: '3.2', name: 'spDescObjectionsBank', description: '' },
    { key: '3.3', name: 'spDescArgumentBank', description: '' },
    { key: '3.4', name: 'spDescPhoneCallScripts', description: '' },
    { key: '3.5', name: 'spDescMeetingStructure', description: '' },
    { key: '3.6', name: 'spDescNeedsDiscovery', description: '' },
  ];

  save() {
    this.http
      .post(
        `/api/tenants/spdescriptions/${this.tenantId}`,
        this.selectedCategories
          .concat(this.selectedCategoriesDepartment)
          .concat(this.selectedCategoriesOperational),
      )
      .subscribe({
        complete: () => {
          this.toastService.showSuccess(MessageText.saved);
        },
        error: () => {
          this.toastService.showError(MessageText.error);
        },
      });
  }
}
